import React, { useState } from 'react';
import Div from '../Div';

export default function Newsletter({ title, subtitle, placeholder }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccess(false);
        setError(false);

        try {
            const webhookUrl = 'https://hook.eu2.make.com/x6zi3fjzgdmxsy48fjlgqw7uffdhmlc6'; // Replace with your actual Make.com webhook URL

            const response = await fetch(webhookUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setSuccess(true);
                setEmail(''); // Clear input field after successful submission
            } else {
                setError(true);
            }
        } catch (err) {
            console.error('Error submitting email:', err);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {title && <h2 className="cs-widget_title">{title}</h2>}
            <Div className="cs-newsletter cs-style1">
                <form onSubmit={handleSubmit} className="cs-newsletter_form">
                    <input
                        type="email"
                        className="cs-newsletter_input"
                        placeholder={placeholder}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit" className="cs-newsletter_btn" disabled={loading}>
                        {loading ? 'Sending...' : <span>Send</span>}
                    </button>
                </form>
                {success && <p className="cs-success_message">✅ Subscription successful!</p>}
                {error && <p className="cs-error_message">❌ Something went wrong. Try again.</p>}
                <Div className="cs-newsletter_text">{subtitle}</Div>
            </Div>
        </>
    );
}
